import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";


import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";

import { permite_acesso, PegarDados1, status2 } from "../../services/api";

import { set, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Alunos_unidade_hist from "../Modulos/alunos_unidade_hist";
import Totalizacao_alunos from "../Modulos/totalizacao";
import Alunos_novos_renovados_bar from "../Modulos/novos_renovados";
import Bolsas_pizza from "../Modulos/bolsas_pizza";
import Fidelizacao from "../Modulos/fidelizacao";
import Bolsas_media from "../Modulos/bolsa_media";
import Fidelizacao_pizza from "../Modulos/fidelizacao_pizza";
import Mensalidade_media from "../Modulos/mesalidade_media";
import Alunos_situacao from "../Modulos/alunos_situacao";
import Material_escolar from "../Modulos/material_escolar";
import Bolsas_pizza_detalhe from "../Modulos/bolsa_pizza_detalhes";
import Fidelizacao_Rede from "../Modulos/Fidelizacao_rede";
import Detalhamento_bolsa_rede from "../Modulos/detalhamento_bolsa_rede";
import Faturamento_estimado from "../Modulos/faturamento_estimado";
import Matriculas_acumuladas from "../Modulos/matriculas_ajustadas";
import Estimativa_geral from "../Modulos/estimativa_geral";

import Checkbox from "../Components/checkbox";

// import { Row, Form, Button, Container, Tab, Tabs, Table, Col } from "react-bootstrap";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Table from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/esm/Col";

import Accordion from 'react-bootstrap/Accordion';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Collapse from 'react-bootstrap/Collapse';


import './index.css';



const schema = yup.object({}).required();

const Estimativa_pagina = () => {

    const stauts = status2();
    console.log("Status2", stauts);


    const usuario = JSON.parse(localStorage.getItem("user"));
    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const token = localStorage.getItem("token");



    // CONTROLE(FUNCIONARIO,TOKEN,COD_UNI)

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const { authenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [acesso, setAcesso] = useState(false);


    const [dataInicio, setDataInicio] = useState('2024-08-31'); // Formato ISO (YYYY-MM-DD)
    // const [dataFim, setDataFim] = useState(new Date().toISOString().split('T')[0]);
    // const [dataFim, setDataFim] = useState('2025-03-31');
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    const novaDataFim = amanha.toISOString().split('T')[0];

    const hoje = new Date();
    const diadehoje = hoje.toISOString().split('T')[0];

    const [dataFim, setDataFim] = useState(diadehoje);

    console.log("Antes", dataInicio);

    // const [startDate, setStartDate] = useState('2023-09-01');
    // const [endDate, setEndDate] = useState(getCurrentDate());

    function formatarData(dataOriginal) {
        // Divide a string da data em ano, mês e dia
        const partes = dataOriginal.split('-');
        // Verifica se a string está no formato correto (ANO-MES-DIA)
        if (partes.length !== 3) {
            return 'Formato de data inválido';
        }
        // Reorganiza as partes da data no formato DIA-MES-ANO
        const dataFormatada = `${partes[2]}-${partes[1]}-${partes[0]}`;
        return dataFormatada;
    }



    const {
        register,
        setValue,
        handleSubmit,
        setFocus,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });



    useEffect(() => {
        (async () => {
            const resultado2 = await permite_acesso(usuario[0].email, token, "HomePage");
            setAcesso(resultado2);
        })();
    }, [dataInicio, dataFim]);

    console.log("Acesso:", acesso);

    console.log("Depois", dataInicio);



    if (!acesso) {

        return (
            <div className="AcessoNegado">
                -- ACESSO NEGADO !!! --

                <a href="/login"> Voltar ao Login</a>


            </div>
        )
    }

    const handleData = (e) => {
        e.preventDefault();
        let dti = document.querySelector(
            "input[name = inicio]"
        ).value;
        console.log(dti);
        setDataInicio(dti);
        let dtf = document.querySelector(
            "input[name = fim]"
        ).value;
        console.log(dtf);
        setDataFim(dtf);

    }
    const handleTotal = (e) => {
        e.preventDefault();
        setDataInicio('2024-08-31');
        setDataFim('2025-12-31');
    };

    const handleCiclo = (e) => {
        e.preventDefault();
        setDataInicio('2024-08-31');
        setDataFim('2025-03-31');
    };

    const handleHoje = (e) => {
        e.preventDefault();
        setDataInicio('2024-08-31');
        setDataFim(diadehoje);
    };

    const handleSoHoje = (e) => {
        e.preventDefault();
        console.log(diadehoje);
        setDataInicio(diadehoje);
        console.log('novaDataFim');
        setDataFim(diadehoje);
    };

    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>
                    <NavDropdown.Item href="/metas">Painel de Metas</NavDropdown.Item>
                    <NavDropdown.Item href="/tesouraria">Tesouraria - Pagamentos</NavDropdown.Item>
                </>
            );
        if (Nperfil.startsWith("DIRETOR")) {
            var numerosString = Nperfil.replace("DIRETOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown.Item key="tesouraria" href="/tesouraria"> Tesouraria - Pagamentos </NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Item href="/metas">Painel de Metas</NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Divider />);
            var codigoDinamico2 = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/upload/${cod_unidade}`}>
                        Assinaturas - {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown title="Assinaturas" id="basic-nav-subdropdown">{codigoDinamico2}</NavDropdown>);


            return (codigoDinamico)


        };
        if (Nperfil.startsWith("SECRETARIA")) {
            var numerosString = Nperfil.replace("SECRETARIA", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown.Item key="tesouraria" href="/tesouraria"> Tesouraria - Pagamentos </NavDropdown.Item>);
            codigoDinamico.push(<NavDropdown.Divider />);
            var codigoDinamico2 = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/upload/${cod_unidade}`}>
                        Assinaturas - {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            codigoDinamico.push(<NavDropdown title="Assinaturas" id="basic-nav-subdropdown">{codigoDinamico2}</NavDropdown>);

            return (codigoDinamico)
        };


    }

    return (

        <div className="Homepage">
            <div className="sticky-top painel">

                <Navbar expand="lg" className="bg-body-tertiary">
                    <Navbar.Brand href="/">Santa Mônica Rede de Ensino</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">

                        <NavDropdown
                            title="UNIDADES"
                        >
                            {Experiment(perfil[0].perfil)}

                        </NavDropdown>

                        <Row>
                            <Form onSubmit={handleData}>

                                <Row>
                                    <Col xs="auto">
                                        <InputGroup>
                                            <InputGroup.Text id="basic-addon1">Data Início</InputGroup.Text>
                                            <Form.Group >
                                                {/* <Form.Label >Data Início: </Form.Label> */}
                                                <Form.Control
                                                    name="inicio"
                                                    type="date"
                                                    placeholder={dataInicio}
                                                    label="Data Início:"
                                                    className=" mr-sm-2" >

                                                </Form.Control>
                                            </Form.Group>
                                        </InputGroup>

                                    </Col>
                                    <Col xs="auto">
                                        <InputGroup>
                                            <InputGroup.Text id="basic-addon1">Data Fim</InputGroup.Text>
                                            <Form.Group >
                                                {/* <Form.Label htmlFor="floatingInput" >Data Início: </Form.Label> */}
                                                <Form.Control
                                                    name="fim"
                                                    type="date"
                                                    placeholder={dataFim}
                                                    label="Data Fim:"
                                                    className=" mr-sm-2" >
                                                </Form.Control>
                                            </Form.Group>
                                        </InputGroup>

                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" type="submit">
                                            Filtrar datas
                                        </Button>
                                    </Col>

                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleCiclo}> Todo Ciclo  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleTotal}> Ano Completo  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleHoje} > Até Hoje  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={handleSoHoje} >  Hoje {formatarData(diadehoje)}  </Button>
                                    </Col>
                                    <Col xs="auto">
                                        <Button variant="primary" onClick={(e) => { navigate("\login") }} > Sair  </Button>
                                    </Col>

                                </Row>


                            </Form>

                        </Row>
                    </Navbar.Collapse>
                </Navbar>

                <Row >

                    <Col lg={12} sm={12}>

                        <Totalizacao_alunos di={dataInicio} df={dataFim} />
                    </Col>

                </Row>
            </div>

            <Row>
                <Col lg={6} sm={6}>
                    <center>
                        <h4>
                            Estimativas

                        </h4>
                        <Estimativa_geral />

                    </center>

                </Col>
            </Row>


        </div>

    );

    function Faturamento_estimado_prop() {

        if (perfil[0].perfil === "GESTOR") {
            return (<Col lg={5} sm={12}>
                <center>
                    <Faturamento_estimado di={dataInicio} df={dataFim} />

                </center>
            </Col>);
        } else {
            return (<Col lg={5} sm={12}>
                <center>
                    {/* <Faturamento_estimado di={dataInicio} df={dataFim} /> */}

                </center>
            </Col>);
        }

    }
};

export default Estimativa_pagina;